import React from 'react';

const StuOnlinePayment = () => {
    return (
        <div>
            Online Payment
        </div>
    );
};

export default StuOnlinePayment;